import "./Footer.css"; // Import your CSS file
import Facebook from "./image/facebook (1).png";
import instagram from "./image/instagram.png";
import tiktok from "./image/tik-tok.png";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer>
      <div className="footer-containertop">
        {t("contact us with social medal")}
      </div>
      <div className="footer-container">
        <div className="footer-column">
          <h4>
            <img src={Facebook} alt="facebook" height={50} width={50} />
          </h4>
          <p>
            <a
              href="https://www.facebook.com/Brdawam?mibextid=ZbWKwL"
              target="_blank"
              rel="noreferrer"
            >
              Bardawam بەردەوام ـ
            </a>
          </p>
        </div>

        <div className="footer-column">
          <h4>
            <img src={instagram} alt="facebook" height={50} width={50} />
          </h4>
          <p>
            <a
              href="https://www.instagram.com/bardawam_plus?igsh=OGQ5ZDc2ODk2ZA"
              target="_blank"
              rel="noreferrer"
            >
              bardawam_plus
            </a>
          </p>
        </div>

        <div className="footer-column">
          <h4>
            <img src={tiktok} alt="facebook" height={50} width={50} />
          </h4>
          <p>
            <a
              href="https://www.tiktok.com/@bardawamplus?_t=8jIwqSJNr9B&_r=1"
              target="_blank"
              rel="noreferrer"
            >
              Bardawam Plus
            </a>
          </p>
        </div>

        <div className="footer-column">
          <h4>
            <img src={Facebook} alt="facebook" height={50} width={50} />
          </h4>
          <p>
            <a
              href="https://www.facebook.com/profile.php?id=100077434846075&mibextid=ZbWKwL"
              target="_blank"
              rel="noreferrer"
            >
              Bardawam Plus
            </a>
          </p>
        </div>

        <hr className="footer-hr" />

        <div className="footer-bottom">
          <span>&copy; 2024 Bardawam Plus</span>
          {/* <a href="/privacy-policy">Privacy Policy</a> */}
          <p>
            <a
              href="https://www.facebook.com/TechTopiaa"
              target="_blank"
              style={{
                color: "#05eeff",
              }}
              rel="noreferrer"
            >
              TechTop
            </a>
            {t("This website created by TechTop")}
            {/* {t("hello")} */}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
